import React from 'react';
import { Menu, Bell, Search, Sun, Moon } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Header = ({ onMenuClick, user }) => {
  const { isDarkMode, toggleTheme } = useTheme();

  // Get user initials from name
  const getInitials = (name) => {
    if (!name) return '';
    const parts = name.split(' ');
    if (parts.length === 1) return parts[0].charAt(0).toUpperCase();
    return (parts[0].charAt(0) + parts[parts.length - 1].charAt(0)).toUpperCase();
  };

  return (
    <header className="bg-white dark:bg-dark-bg shadow-sm border-b border-gray-200 dark:border-dark-border px-4 lg:px-6 py-3 lg:py-4 transition-colors duration-200">
      <div className="flex items-center justify-between">
        {/* Left side - Menu button and search */}
        <div className="flex items-center space-x-4">
          <button
            onClick={onMenuClick}
            className="lg:hidden p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors duration-200"
          >
            <Menu className="w-5 h-5 text-gray-600 dark:text-dark-text" />
          </button>
          
          {/* Search Bar */}
          <div className="relative hidden md:block">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search className="h-4 w-4 text-gray-400 dark:text-dark-muted" />
            </div>
            <input
              type="text"
              placeholder="Search referrals, commissions..."
              className="block w-80 pl-10 pr-3 py-2 border border-gray-300 dark:border-dark-border dark:bg-dark-bg dark:text-dark-text rounded-lg text-sm placeholder-gray-500 dark:placeholder-dark-muted focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-colors duration-200"
            />
          </div>
        </div>
        
        {/* Right side - Theme toggle, Notifications and profile */}
        <div className="flex items-center space-x-3">
          {/* Mobile search button */}
          <button className="md:hidden p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors duration-200">
            <Search className="w-5 h-5 text-gray-600 dark:text-dark-text" />
          </button>

          {/* Theme Toggle */}
          <button 
            onClick={toggleTheme}
            className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-slate-700 transition-all duration-200"
            title={isDarkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
          >
            {isDarkMode ? (
              <Sun className="w-5 h-5 text-amber-400" />
            ) : (
              <Moon className="w-5 h-5 text-slate-600" />
            )}
          </button>
          
          {/* Notifications */}
          <div className="relative">
            <button className="p-2 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors duration-200 relative">
              <Bell className="w-5 h-5 text-gray-600 dark:text-dark-text" />
              <span className="absolute top-1 right-1 w-2 h-2 bg-red-500 rounded-full"></span>
            </button>
          </div>
          
          {/* Profile dropdown */}
          <div className="relative">
            <button className="flex items-center space-x-3 px-2 py-1 rounded-md hover:bg-gray-100 dark:hover:bg-slate-700 transition-colors duration-200">
              <div className="hidden md:block text-right">
                <p className="text-base font-medium text-gray-900 dark:text-dark-text">{user?.name || 'User'}</p>
                <p className="text-sm text-gray-500 dark:text-dark-muted">{user?.role || 'Role'}</p>
              </div>
              <div className="w-10 h-10 bg-primary-100 dark:bg-primary-900 rounded-full flex items-center justify-center">
                <span className="text-primary-700 dark:text-primary-300 font-semibold text-sm">
                  {user ? getInitials(user.name) : 'U'}
                </span>
              </div>
            </button>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
